module.exports = __webpack_public_path__ + "img/air.a827d5c5.jpg";